import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import wrapReact from '../../util/react';
import { wrapFunc } from '../../util/js';
import {
  actCreateAccount,
  actDeleteAccount,
  actGetAccounts,
  actUpdateAccount,
} from '../../redux/action/account';
import { FETCH_CONTINIOUS_INTERVAL } from '../../config';
import { actGetDevices } from '../../redux/action/device';

export default function CompWrapper(Comp, name) {
  class wrapComp extends Component {
    getAccount = wrapFunc((value, cb, intervalID) => {
      const { auth, intl, dispatch } = this.props;
      clearInterval(intervalID);
      actGetAccounts(
        dispatch,
        {
          token: auth.token,
          lang: intl.locale,
          email: auth.email,
        },
        cb,
      );
      return setInterval(
        actGetAccounts.bind(
          this,
          dispatch,
          {
            token: auth.token,
            email: auth.email,
          },
          cb,
        ),
        FETCH_CONTINIOUS_INTERVAL,
      );
    }, 'getAccount');

    createAccount = wrapFunc((data, cb) => {
      const { auth, intl, dispatch } = this.props;
      actCreateAccount(
        dispatch,
        {
          token: auth.token,
          lang: intl.locale,
          DisplayName: data.DisplayName,
          SerialNumber: data.SerialNumber,
        },
        cb,
      );
    }, 'createAccount');

    updateAccount = wrapFunc((data, cb) => {
      const { auth, intl, dispatch } = this.props;
      actUpdateAccount(
        dispatch,
        {
          token: auth.token,
          lang: intl.locale,
          Name: data.Name,
          DisplayName: data.DisplayName,
          Password: data.Password,
        },
        cb,
      );
    }, 'updateAccount');

    deleteAccount = wrapFunc((data, cb) => {
      const { auth, intl, dispatch } = this.props;
      actDeleteAccount(
        dispatch,
        {
          token: auth.token,
          lang: intl.locale,
          Name: data.Name,
        },
        cb,
      );
    }, 'deleteAccount');

    getDeviceType = wrapFunc((cb) => {
      const { auth, intl, dispatch } = this.props;
      actGetDevices(
        dispatch,
        {
          token: auth.token,
          lang: intl.locale,
        },
        cb,
      );
    }, 'getDeviceType');

    render() {
      const {
        devices, accounts, ui, dispatch,
      } = this.props;
      return (
        <Comp
          {...this.props}
          ui={ui}
          accounts={accounts}
          devices={devices}
          getAccount={this.getAccount}
          createAccount={this.createAccount}
          updateAccount={this.updateAccount}
          deleteAccount={this.deleteAccount}
          getDeviceType={this.getDeviceType}
          dispatch={dispatch}
        />
      );
    }
  }
  wrapComp.propTypes = {
    ui: PropTypes.object.isRequired,
    accounts: PropTypes.object.isRequired,
    devices: PropTypes.object.isRequired,
    intl: PropTypes.shape({
      locale: PropTypes.string.isRequired,
    }).isRequired,
    auth: PropTypes.shape({
      token: PropTypes.string.isRequired,
      email: PropTypes.string.isRequired,
    }).isRequired,
    dispatch: PropTypes.func.isRequired,
  };
  function mapStateToProps(state) {
    return {
      auth: state.get('auth'),
      accounts: state.get('account'),
      devices: state.get('device'),
      ui: state.get('ui').uiAccount,
    };
  }
  return connect(mapStateToProps)(wrapReact(wrapComp, name));
}
